import { getFirstDayOfWeek } from 'app/functions';
import {
  localeSelector,
  monthsTitleSelector,
  weekdaysSelector,
  weekdaysShortSelector,
} from 'app/store/selectors';
import { useEffect, useState } from 'react';
import { useAppSelector } from 'app/hooks/appHooks';

type CalendarData = {
  firstDayOfWeek: number;
  months: string[];
  days: { long: string; short: string }[];
};

export const useCalendarData = () => {
  const locale = useAppSelector(localeSelector);

  const weekdaysShort = useAppSelector(weekdaysShortSelector);
  const weekdays = useAppSelector(weekdaysSelector);
  const monthsTitle = useAppSelector(monthsTitleSelector);
  const [calendarData, setCalendarData] = useState<CalendarData | null>(null);
  useEffect(() => {
    const firstDayOfWeek = getFirstDayOfWeek(locale);

    setCalendarData({
      firstDayOfWeek,
      months: monthsTitle,
      days: (() => {
        const weeks: { long: string; short: string }[] = [];
        for (let i = 0; i < 7; i++) {
          weeks.push({ short: weekdaysShort[i], long: weekdays[i] });
        }

        if (firstDayOfWeek === 1) {
          const sun = weeks.shift();
          if (sun) {
            weeks.push(sun);
          }
        }

        return weeks;
      })(),
    });
  }, [locale]);

  return calendarData;
};
